import "../../css/OptionsModal.css";
import { FiEye } from "react-icons/fi";

const OptionsModal = ({
  open,
  handleClose,
  item,
  anchorPosition,
  onSelect,
}) => {
  if (!open) return null;

  const options = [
    {
      label: "View Balance",
      icon: <FiEye style={{ marginRight: "8px" }} />,
    },
  ];

  // Adjust position to fit within a table cell (e.g., offset from anchorPosition)
  const adjustedStyle = {
    top: `${anchorPosition.top}px`, // Use provided top
    left: `${anchorPosition.left}px`, // Use provided left
    position: "absolute", // Ensure absolute positioning
    zIndex: 1000, // Ensure it stays above other elements
    maxHeight: "200px", // Limit height to prevent overflow
    overflowY: "auto", // Allow scrolling if needed
  };

  return (
    <div className="options-dropdown-overlay" onClick={handleClose}>
      <div
        className="options-dropdown"
        style={adjustedStyle}
        onClick={(e) => e.stopPropagation()}
      >
        <ul>
          {options.map((opt, index) => (
            <div
              key={index}
              className="option-item"
              onClick={() => onSelect(opt.label)}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "8px 12px",
                cursor: "pointer",
                borderBottom:
                  index < options.length - 1 ? "1px solid #ddd" : "none",
              }}
            >
              {opt.icon}
              <span>{opt.label}</span>
            </div>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default OptionsModal;
